import type { AccordionButtonProps, AccordionItemProps } from "@ecco/ui/accordion";
import { space } from "@ecco/ui/tokens";

export const accordionItemStyles: AccordionItemProps = {
    w: "100%",
    borderBottomWidth: space["0.2"],
    borderColor: "gray.100",
    // Theme removes the last border, we want it back
    _last: { borderBottomWidth: space["0.2"] },
    backgroundColor: "transparent",
    borderRadius: 0,
};

export const accordionButtonStyles: AccordionButtonProps = {
    w: "100%",
    borderRadius: 0,
    textAlign: "left",
    fontSize: ["mobileBodyTextNormal", "mobileBodyTextNormal", "desktopBodyTextLarge"],
    fontWeight: "semibold",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "transparent",
    color: "black",
    py: 4,
    px: 0,
    _expanded: { backgroundColor: "transparent" },
    _hover: { bg: "transparent" },
};
